import React from 'react';

import TextHelper from './TextHelper';

export default class ValidateHelper {
  static listErrors(errors = {}) {
    return Object.entries(errors).map(([key, error]) => (
      <div key={key}>
        <b>•</b> {error}
      </div>
    ));
  }

  static length(str, min = 0, max = Infinity) {
    const length = TextHelper.toString(str).length;
    return length >= min && length <= max;
  }

  static email(str) {
    return /^([a-zA-Z0-9_.-]+)@([a-zA-Z0-9_-]+)\.([a-zA-Z]{2,5})(\.[a-zA-Z]{2,5})?$/.test(TextHelper.toString(str));
  }

  static phone(str, digits = 10) {
    return TextHelper.toString(str).replace(/\D/g, '').length >= digits;
  }

  static cpf(str) {
    let cpf = TextHelper.unmask(str);

    if (cpf.length !== 11) {
      return false;
    }

    let soma = 0;
    let resto;

    for (let i = 1; i <= 9; i++) {
      soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    }

    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) {
      resto = 0;
    }

    if (resto !== parseInt(cpf.substring(9, 10))) {
      return false;
    }

    soma = 0;
    for (let i = 1; i <= 10; i++) {
      soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    }

    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) {
      resto = 0;
    }

    if (resto !== parseInt(cpf.substring(10, 11))) {
      return false;
    }

    return true;
  }

  static cnpj(str) {
    let cnpj = TextHelper.unmask(str);

    if (cnpj.length !== 14) {
      return false;
    }

    // Validar DVs
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

    if (resultado.toString() !== digitos.charAt(0)) {
      return false;
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

    if (resultado.toString() !== digitos.charAt(1)) {
      return false;
    }

    return true;
  }

  static cep(str) {
    return this.length(TextHelper.unmask(str), 8, 8);
  }
}
